export default "__VITE_ASSET__DoHIZ1sl__"